import { Component } from "react";

import { number, rate } from "common/formats";
import { FETCH_SUMMARY_DATA } from "common/actions/dashboard";
import { Placeholder } from "common/components/placeholder";
import { HelpHover } from "common/components/helpHover";

import { getDateRangeAsString, drillThrough, formatAmountWithCurrency } from "../widgetHelper";

export class TrendlineSummary extends Component {
    static getCount(data, key, count = "count") {
        const record = data.find((i) => i.name === key);
        return record && record[count] ? record[count] : 0;
    }
    
    constructor(props) {
        super(props);
        this.state = {
            prevLoaded: false,
            error: false
        };
    }
    
    componentDidMount() {
        // Get Prev Summarry Data that is shared in all tabs.  Pas in the url from the submodel
        const prevRange = this.props.dateRanges[1];
        if (this.existingPromiseRequest) {
            this.existingPromiseRequest.cancel();
        }
    
        this.existingPromiseRequest = FETCH_SUMMARY_DATA({
            url: this.props.subModel.get("api_endpoint")([this.props.first_pivot_key]),
            start: prevRange.startDate.toISOString(),
            end: prevRange.endDate.toISOString(),
            q: this.props.widgetQualifiers
        }).then((data) => {
            const currentPeriodTotal = TrendlineSummary.getCount(this.props.data, this.props.pivotName, this.props.count);
            const prevTotals = this.getPreviousTotals(data);
            const prevCount = TrendlineSummary.getCount(prevTotals, this.props.pivotName, this.props.count) || 0;
            let change;
            if (this.props.widgetSubType === "fees" && this.props.count === "topCount") {
                change = prevCount === 0 ? "-%" : currentPeriodTotal - prevCount;
            } else {
                change = prevCount === 0 ? "-%" : ((currentPeriodTotal - prevCount) / prevCount) * 100;
            }
            this.setState({
                prevLoaded: true,
                prevCount,
                error: false,
                change
            });
        }, (error) => {
            this.setState({
                prevLoaded: true,
                error: true
            });
        });
    }
    
    componentWillUnmount() {
        if (this.existingPromiseRequest) {
            this.existingPromiseRequest.cancel();
        }
    }
    
    getPreviousTotals(data) {
        const tabPivot = this.props.first_pivot_key;
        const topField = this.props.subModel.get("trendline").reactProps.countField;
        const bottomField = this.props.subModel.get("trendline").reactProps.otherCountField;
        return data.map((item) => ({
            tabPivot, topField, bottomField, name: item[tabPivot], topCount: Math.abs(item[topField]), bottomCount: Math.abs(item[bottomField]), ...item
        }));
    }
    
    getValueOrLoader(format, value, isChange = false) {
        if (this.state.prevLoaded) {
            if (isChange && this.state[value] === "-%") {
                return "-%";
            }
            return isChange && this.state[value] > 0 ? `+${format(this.state[value])}` : format(this.state[value]);
        }
        return <Placeholder />;
    }
    
    render() {
        if (this.state.error) {
            return null;
        }
        
        const drillDown = (e) => {
            drillThrough(this.props);
        };
        const Prefix = this.props.subModel.get("trendline").reactProps.summaryTitle;
        const count = TrendlineSummary.getCount(this.props.data, this.props.pivotName, this.props.count);
        let summaryLabel;
        let formatF;
        
        if (this.props.count === "topCount") {
            // eslint-disable-next-line sentence-case/sentence-case
            summaryLabel = this.props.widgetSubType === "fees" ? "Effective Rate" : `${Prefix} COUNT`;
            formatF = this.props.widgetSubType === "fees" ? rate : number;
        } else {
            summaryLabel = this.props.widgetSubType === "fees" ? "SALES AMOUNT" : `${Prefix} AMOUNT`;
            formatF = (a) => formatAmountWithCurrency(a, 10_000_000);
        }
        const legend = this.props.count === "topCount" ? "line" : "block";
        
        return (
            <div onClick={drillDown} className="summary summary-bar">
                <div className="wrap row summary-row">
                    <div className="col-xs-4">
                        <div className="summary-block">
                            <div className="block-name">
                                <HelpHover size="sm" title="Current period" body={`Data reported between ${getDateRangeAsString(this.props.dateRanges[0])}`}>
                                    <div className={`current-legend-${legend}`}/>
                                    <span className="value-label">{summaryLabel}</span>
                                </HelpHover>
                            </div>
                            <div className="block-value">{formatF(count)}</div>
                        </div>
                    </div>
                    <div className="col-xs-4">
                        <div className="summary-block">
                            <div className="block-name">
                                <HelpHover size="sm" title="Prior period" body={`Data reported between ${getDateRangeAsString(this.props.dateRanges[1])}`}>
                                    <div className={`prior-legend-${legend}`}/>
                                    <span className="value-label">PRIOR PERIOD</span>
                                </HelpHover>
                            </div>
                            <div className="block-value prior">{this.getValueOrLoader(formatF, "prevCount")}</div>
                        </div>
                    </div>
                    <div className="col-xs-4">
                        <div className="summary-block">
                            <div className="block-name">
                                <HelpHover size="sm" title="CHANGE" body="The change between the current and prior periods">
                                    <span className="change-label value-label">CHANGE</span>
                                </HelpHover>
                            </div>
                            <div className="block-value change-value">{this.getValueOrLoader(rate, "change", true)}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
